<ChapterNav params="{params}" segment="video" />
{#if ch}
  <div class="section" id="chapter">
    <div class="container pt-5">
      <div class="has-text-centered mt-5 mb-5">
        <h2 class="is-size-3">
          {@html ch.title}
        </h2>
      </div>

      <div
        class="video mb-5 is-three-fifths-desktop is-offset-one-fifth-desktop"
      >
        {#if videoUrl}
          <Videoplayer
            videoUrl="{videoUrl}"
            on:videoPlayed="{setVideoPlayed}"
          />
        {/if}
      </div>
      <div class="has-text-right">
        <button
          class="button is-success"
          disabled="{videoPlayed}"
          on:click="{setVideoPlayed}"
        >
          <span class="icon is-small"> <i class="fas fa-check"></i> </span>
          <span>Ja, ich habe das Video angesehen</span>
        </button>
        <button
          class="button"
          disabled="{!videoPlayed}"
          on:click="{() => push('/platzreife/' + ch.slug + '/regeln')}"
        >
          <span>Die Regeln dazu</span>
          <span class="icon is-small">
            <i class="fas fa-chevron-right"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
{/if}

<script>
import { onMount } from "svelte";

import { currentChapter, userProgress } from "./stores";
import { ChapterService } from "./services/chapter.service";
import ChapterNav from "./ChapterNav.svelte";
import { push } from "svelte-spa-router";
import Videoplayer from "./Videoplayer.svelte";
import { progressSvc } from "./services/progress.service";

let ch, up, videoPlayed, chapterSvc, videoUrl;
export let params = {};

const setVideoPlayed = () => {
  videoPlayed = true;
  chapterSvc.setVideoPlayed();
};
const initData = () => {
  if (up && ch) {
    videoPlayed = progressSvc.hasVideoPlayed();
  }
};

onMount(() => {
  currentChapter.subscribe((value) => {
    if (value == undefined) {
      return;
    }
    ch = value;
    chapterSvc = new ChapterService(ch);
    videoUrl = ch.videoUrl;
    initData();
  });
  userProgress.subscribe((data) => {
    up = data;
    initData();
  });
});
</script>

<style type="text/scss">
@import "./scss/video-iframe";
.chapter-text {
  transition: all 0.3s ease;
  position: relative;
}
.disabled-notice {
  display: none;
}
.disabled {
  .chapter-text {
    pointer-events: none;
    opacity: 0.2;
    filter: blur(3px);
    max-height: 500px;
    overflow: hidden;
  }
  .disabled-notice {
    display: block;
  }
}
</style>
